import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/authentication/login.service';

@Component({
  selector: 'app-admins',
  templateUrl: './admins.component.html',
  styleUrls: ['./admins.component.css']
})
export class AdminsComponent implements OnInit {

  	menu:any;
  	permissions = [];

	constructor(public auth: LoginService) { }

	ngOnInit() {
		this.menu = [
			{name:'Clientes', desc:'Clientes', icon:'fas fa-user-tag', url:'/clients', perm: 'ADMIN-CRUD-ROLE'},
			{name:'Usuarios', desc:'Mantenimiento de usuarios', icon:'fas fa-users', url:'/users', perm: 'ADMIN-CRUD-USER'},
			{name:'Perfiles', desc:'Perfiles de usuario', icon:'fas fa-key', url:'/roles', perm: 'ADMIN-CRUD-ROLE'},
            //{name:'Parámetros', desc:'Parámetros de Sistema', icon:'fas fa-sliders-h', url:'/sysparams', perm: 'ADMIN-CRUD-SYSPARAMS'}
		];

		this.auth.getPermissions().then(x => {
            this.permissions = x;
        });
	}

	hasPermission(str:string){
        if( this.permissions.indexOf(str) > -1 ){
            return true;
        }
        else{
            return false;
        }
    }

}
